import dayjs from 'dayjs';

export type FeedbackDatePreset = 'all' | '30-days' | '90-days' | 'custom';

export interface FeedbackDateRange {
  preset: FeedbackDatePreset;
  label: string;
  starts: string;
  ends: string;
}

export const allTimeFeedbackRange: FeedbackDateRange = {
  preset: 'all',
  label: 'All time',
  starts: '',
  ends: '',
};

export const feedbackDateRangeForPreset = (
  preset: Exclude<FeedbackDatePreset, 'custom'>,
): FeedbackDateRange => {
  if (preset === 'all') return allTimeFeedbackRange;

  const days = preset === '30-days' ? 30 : 90;
  return {
    preset,
    label: `Past ${days} days`,
    starts: dayjs().subtract(days - 1, 'day').format('MM/DD/YYYY'),
    ends: dayjs().format('MM/DD/YYYY'),
  };
};

export const customFeedbackDateRange = (
  starts: string,
  ends: string,
): FeedbackDateRange => ({
  preset: 'custom',
  label: 'Custom range',
  starts: dayjs(starts).format('MM/DD/YYYY'),
  ends: dayjs(ends).format('MM/DD/YYYY'),
});
